export const refreshNavigate = (href: string) => {
  window.location.href = href;
}